import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { withRouter } from 'react-router-dom';
import { get, orderBy } from 'lodash';
import GenericListPair from 'modules/common/components/GenericListPair';
import Chat, { fbDB, ADMIN_ID } from '../../../chat/Chat';


const ChatSupport = ({ match, history }) => {
  
  const [list, setList] = useState([])

  useEffect(() => {
    fbDB.ref('rooms').on('value', (snapshot) => {
      if(snapshot.val()){

        const reduceData = Object.entries(snapshot.val()).reduce((current, accumulator) => {

          if(get(accumulator, '1.date_time'))
            return [
              ...current,
              {
                room: get(accumulator, '0'),
                ...get(accumulator, '1'),
                ...get(accumulator, '1.date_time')
              }
            ]
          return current
        }, [])

        const data = orderBy(reduceData, ['seconds'], ['desc'])
        
        setList(data)
      }
    })
  }, [])
  
  return (
    <div className="card-content-listing">
      <GenericListPair 
        selectedKey="room"
        selected={match.params.id}
        moduleName="Chat Support"
        data={list}
        renderItem={(item) => {

          const messages = Object.values(get(item, 'messages'))

          return (
            <>
              <div className="px-3 py-3 w-100">
                <h3>{get(item, 'information.client').toUpperCase()}</h3>
                <p className="text-success">{get(messages, `${messages.length-1}.id`) === ADMIN_ID ? 'You: ' : ''}{get(messages, `${messages.length-1}.message`)}</p>
                <small className="text-primary float-right">{moment.unix(get(item, 'seconds')).format('MM/DD/YYYY HH:mm:ss A')}</small>
              </div>
            </>
          )
        }}
        handleSelectRow={(item) => {
          history.push(`/general-settings/chat-support/${get(item, 'room')}`);
        }}
        renderContent={() => {
          return (
            <div className="p-2">
              {match.params.id &&
                (<Chat room={match.params.id} />)}
              {!match.params.id && (
                <div className="d-flex">
                  <p className="m-auto">
                    <b>NO ROOM SELECTED!!!</b>
                  </p>
                </div>
              )}
            </div>
          )
        }}
      />
    </div>
  )
}



ChatSupport.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired
}

export default withRouter(ChatSupport);